<div class="wrap">
  <h2>{{title}}</h2>
  <form [formGroup]="subHelpForm" id="subHelpForm" class="input_google_search" (ngSubmit)="onSubmit()"
    *ngIf="subHelpForm">

    <mat-form-field appearance="outline">
      <mat-label>Titre</mat-label>
      <input matInput type="text" formControlName="title" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="descriptionField">
      <mat-label>Description</mat-label>
      <input matInput type="text" formControlName="description" />
    </mat-form-field>

    <div class="upload">
      <div class="input">
        <div class="input_uplaod_perso" appChangeColorTheme attribute="bgc">
          <fa-icon [icon]="getFaIcon('faUpload')"></fa-icon>
          <p>Importer une vidéo</p>
        </div>
        <input type="file" class="input_default_file" (input)="uploadVideo($event)" />
      </div>



      <div [ngSwitch]="data.action">
        <ng-container *ngSwitchCase="'add'">
          <div class="file_name" *ngIf="this.newVideo">
            <fa-icon [icon]="getFaIcon('faFile')" appChangeColorTheme attribute="color"></fa-icon>
            {{ this.newVideo?.name }}
          </div>
        </ng-container>

        <div class="file_name" *ngSwitchCase="'edit'">
          <fa-icon [icon]="getFaIcon('faFile')" appChangeColorTheme attribute="color"></fa-icon>
          {{ this.newVideo ? this.newVideo.name : this.data.help?.videoName }}
        </div>
      </div>
    </div>

  </form>

  <div class="btn_action">
    <button type="button" class="back" (click)="dialogRef.close()">Fermer</button>
    <button type="submit" class="confirm" form="subHelpForm" [disabled]="subHelpForm.invalid"
      [style.opacity]="subHelpForm.invalid? .5 : 1" appChangeColorTheme attribute="bgc">{{btnConfirm}}</button>

  </div>
</div>
